export default "__VITE_ASSET__Ci93w$Wj__"